exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget[data-v-04dffc43] {\n  max-height: 277px;\n}\n", ""]);

// exports
